import React, { useEffect, useRef, useState } from "react";
import FaqAndContactSection from "../components/Shared/FaqAndContactSection";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "../assets/SvgIcons";
import DelarsTestimonial from "../components/DelarInfo/DelarsTestimonial";

const dealerTestimonials = [
  {
    imgUrl:
      "https://cdn.discordapp.com/attachments/920721313105080390/1305568467910529104/image_1.png?ex=673380e3&is=67322f63&hm=71b1650d3a9bca63038d77b56b7804ab533a22575c2c9049bbb493bafbbdc648&",
    name: "John Doe",
    brand: "Dummy Brand 1",
    location: "Country X",
    initial: "JD",
    review: "Great experience with the transaction. Highly recommended!",
  },
  {
    imgUrl:
      "https://cdn.discordapp.com/attachments/920721313105080390/1305568467910529104/image_1.png?ex=673380e3&is=67322f63&hm=71b1650d3a9bca63038d77b56b7804ab533a22575c2c9049bbb493bafbbdc648&",
    name: "Jane Smith",
    brand: "Dummy Brand 2",
    location: "Country Y",
    initial: "JS",
    review:
      "Smooth transaction and fast delivery. Very pleased with my purchase.",
  },
  {
    imgUrl:
      "https://cdn.discordapp.com/attachments/920721313105080390/1305568467910529104/image_1.png?ex=673380e3&is=67322f63&hm=71b1650d3a9bca63038d77b56b7804ab533a22575c2c9049bbb493bafbbdc648&",
    name: "Alex Johnson",
    brand: "Dummy Brand 3",
    location: "Country Z",
    initial: "AJ",
    review: "Excellent service, and the product was just what I expected.",
  },
  {
    imgUrl:
      "https://cdn.discordapp.com/attachments/920721313105080390/1305568467910529104/image_1.png?ex=673380e3&is=67322f63&hm=71b1650d3a9bca63038d77b56b7804ab533a22575c2c9049bbb493bafbbdc648&",
    name: "Emily White",
    brand: "Dummy Brand 4",
    location: "Country W",
    initial: "EW",
    review: "Fast processing and excellent customer support. Very satisfied!",
  },
  {
    imgUrl:
      "https://cdn.discordapp.com/attachments/920721313105080390/1305568467910529104/image_1.png?ex=673380e3&is=67322f63&hm=71b1650d3a9bca63038d77b56b7804ab533a22575c2c9049bbb493bafbbdc648&",
    name: "Chris Lee",
    brand: "Dummy Brand 5",
    location: "Country V",
    initial: "CL",
    review: "Great customer service and seamless experience. Will buy again.",
  },
];

const faqs = [
  {
    id: 224,
    question: "What is the Watch Collection?",
    answer:
      "The Watch Collection lets you manage and track all of your watches online. Simply enter each watch's details and, if you'd like, add your own photos. You'll then have access to historical price trends, as well as projections of your timepieces' future financial performance. You can also use the Watch Collection to follow other watches you are interested in.",
  },
  {
    id: 225,
    question: "Do I have to own a watch to add it to my Watch Collection?",
    answer:
      "No, you can also follow watches that you are simply interested in. To track a watch's performance, enter its reference number or brand, model, and condition and select the option 'I don't own this watch.'",
  },
  {
    id: 226,
    question: "How many watches can I add to my Watch Collection?",
    answer: "You may add an unlimited number of watches.",
  },
  {
    id: 227,
    question:
      "Why is there a watch in my Watch Collection that I didn't personally add?",
    answer:
      "As soon as you purchase a watch on WristLink, it is automatically added to your Watch Collection, allowing you to track its value over time.",
  },
  {
    id: 228,
    question: "Which estimated values are available in the Watch Collection?",
    answer:
      "You can view the estimated value and change in value of each individual watch, as well as your entire collection.",
  },
  {
    id: 229,
    question: "How often is the estimated value updated?",
    answer:
      "Estimated values are reassessed on a daily basis. However, price fluctuations are only visible across longer periods of time.",
  },
  {
    id: 231,
    question: "Can I save personal information in the Watch Collection?",
    answer: "Yes, you can add your own photos and notes to each watch.",
  },
  {
    id: 232,
    question: "Can I add rare timepieces to the Watch Collection?",
    answer:
      "Yes, you can add any watch to your Watch Collection so that it is complete. That being said, there may be little to no data available on rare watches. If the same model is added by other users and we have sufficient data, new information will be added to your Watch Collection automatically.",
  },
  {
    id: 350,
    question: "Why are Rolex watches so expensive?",
    answer:
      "It's very difficult to buy a Rolex from offline retailers. At the same time, demand is extremely high, which in turn drives prices upward. Rolex is renowned for their premium quality, high precision, and innovative designs. As a result, Rolex watches enjoy tremendous prestige and are often considered status symbols. What's more, Rolex models are highly likely to increase in value, which also contributes to the brand's appeal.",
  },
];
const infoData = [
  {
    title: "Realize Your Potential With WristLink",
    content: [
      " Sell your watches on the world's leading marketplace for luxury watches",
      " Build on our experience, gained from 1.5 million successful sales worldwide",
      " Reach affluent buyers from over 150 countries every month",
      " Take advantage of our secure and transparent payment processing – even internationally",
      " Rely on our experienced team to help you every step of the way",
    ],
    imgUrl:
      "https://cdn.discordapp.com/attachments/920721313105080390/1305573370745720973/Group_9.png?ex=67338573&is=673233f3&hm=49bc36497a55456276097e59c02289ecd287b88de11fbeb5ae6fe6206ef8473e&", // Add the image URL here
  },
];
const inspirationSlideData = [
  {
    imgUrl:
      "https://static.chrono24.com/images/default/dealerinfo/redesign/how-it-works-1-xs.svg",
    title: "Create Your Dealer Account",
    description:
      "Lay the foundation for your success with WristLink by creating a dealer account. Send us your basic business information. After carefully reviewing your information and documents, we'll activate your account and you'll be ready to begin your 30-day trial.",
  },
  {
    imgUrl:
      "https://static.chrono24.com/images/default/dealerinfo/redesign/how-it-works-2-xs.svg",
    title: "Start Your 30-Day Trial",
    description:
      "Learn more about WristLink and see how you can expand your customer base and increase your sales with us. Create as many listings as you want for free, and they'll stay free during your 30-day trial period. We only charge a commission fee for successful sales.",
  },
  {
    imgUrl:
      "https://static.chrono24.com/images/default/dealerinfo/redesign/how-it-works-3-xs.svg",
    title: "Flexible Packages That Grow With Your Business",
    description:
      "Do you sell hundreds of watches? Or do you only trade in a select number of collector's pieces? The size of your dealer package is based on your needs and the number of listings you have.",
  },
];
const dealerBenefits = [
  {
    imgUrl:
      "https://static.chrono24.com/images/default/illustrations/buyer.svg",
    title: "600,000 Daily Visitors",
    description:
      "Every month, over 9 million watch lovers search for the perfect watch on our marketplace.",
  },
  {
    imgUrl:
      "https://static.chrono24.com/images/default/illustrations/buyers-protection.svg",
    title: "International Payment Processing",
    description:
      "Our Trusted Checkout service makes international transactions a breeze. You receive your money safely and on time, no matter where the buyer is located.",
  },
  {
    imgUrl:
      "https://static.chrono24.com/images/default/illustrations/no-contract-term.svg",
    title: "Flexible Contract Term",
    description:
      "We're certain that using WristLink will significantly boost your sales – and if not, you can cancel at anytime.",
  },
  {
    imgUrl:
      "https://static.chrono24.com/images/default/illustrations/multi-language.svg",
    title: "We Speak 22 Languages, So You Don't Have To",
    description:
      "Your listings are automatically translated into 22 languages – so you can sell your watches anywhere in the world.",
  },
  {
    imgUrl:
      "https://static.chrono24.com/images/default/illustrations/support.svg",
    title: "Personal Support",
    description:
      "Our team is always available to help via email or phone. That way, you can get in touch with someone at WristLink whenever you need to.",
  },
  {
    imgUrl:
      "https://static.chrono24.com/images/default/illustrations/article-import.svg",
    title: "Simple & Easy to Use",
    description:
      "Already have your own online store? If you have at least 50 items on your site, we can automatically import your listings without you having to lift a finger.",
  },
];

const watchPricingTiers = [
  {
    watches: "Up to 25 watches",
    price: "€199",
  },
  {
    watches: "Up to 50 watches",
    price: "€369",
  },
  {
    watches: "Up to 75 watches",
    price: "€499",
  },
  {
    watches: "Up to 100 watches",
    price: "€629",
  },
  {
    watches: "Up to 150 watches",
    price: "€829",
  },
  {
    watches: "Up to 250 watches",
    price: "€1,069",
  },
  {
    watches: "Up to 350 watches",
    price: "€1,299",
  },
  {
    watches: "Up to 500 watches",
    price: "€1,549",
  },
  {
    watches: "Up to 700 watches",
    price: "€1,899",
  },
  {
    watches: "Up to 1000 watches",
    price: "€2,199",
  },
];
const dealerFeatures = [
  {
    icon: "https://cdn-icons-png.flaticon.com/128/568/568717.png",
    description:
      "Automatically import your listings from your own online store",
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/128/17999/17999688.png",
    description: "Showcase your business on your own dealer page on WristLink",
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/128/726/726569.png",
    description: "Your company logo will be displayed in your listings",
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/128/2893/2893811.png",
    description: "Book top placements to increase your reach",
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/128/4662/4662255.png",
    description:
      "The size of your package is flexible, and automatically adapts to your needs",
  },
];

const DealerInfo = () => {
  return (
    <>
      <HeroSection />

      <InfoGraphicsSection data={infoData} />
      <InspirationalSection />
      <DelarRegistration style={{ marginTop: 64 }} />
      {/* STICKY CTA SECTION */}
      <InspirationalSlide data={inspirationSlideData} />

      <InspirationalSection3 data={dealerBenefits} />
      <ProfessionalPackageSection
        watchPricingTiers={watchPricingTiers}
        dealerFeatures={dealerFeatures}
      />
      <DelarsTestimonial
        reviews={dealerTestimonials}
        sectionClassName={"bg-[#F3F3F3] text-black"}
        navBtnStyle={{ color: "black" }}
        ctaBtnStyle={{ borderColor: "black" }}
        sectionTitle={"WristLink Dealer Testimonials"}
      />
      <FaqSection faqs={faqs} />
    </>
  );
};

export default DealerInfo;

const HeroSection = () => {
  const imgUrl =
    "https://cdn.discordapp.com/attachments/920721313105080390/1305573370745720973/Group_9.png?ex=67338573&is=673233f3&hm=49bc36497a55456276097e59c02289ecd287b88de11fbeb5ae6fe6206ef8473e&";
  return (
    <section className="bg-[#F6F2EE] min-h-[420px]">
      <div className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex lg:flex-row md:flex-col-reverse sm:flex-col-reverse  items-center gap-4">
        <div className="lg:w-1/2 md:w-full sm:w-full my-auto flex flex-col lg:items-start md:items-center sm:items-center  ">
          <h3 className="lg:text-lg md:text-md sm:text-sm uppercase font-normal mb-2">
            {" "}
            Become a WristLink Dealer
          </h3>
          <h1 className="lg:text-6xl md:text-4xl sm:text-3xl lg:text-left md:text-center sm:text-center font-medium mb-8">
            Open Your Door to 600,000 Watch Enthusiasts Every Day
          </h1>
          {/* CTA */}
          <Link
            to={"/dealer-info/get-started"}
            className="w-fit px-8 py-3 rounded bg-black text-white font-semibold"
          >
            {" "}
            Try WristLink for 30 days
          </Link>
        </div>
        <div className="lg:w-1/2 md:w-full sm:w-full">
          <div
            style={{ backgroundImage: `url(${imgUrl})` }}
            className="ml-auto lg:w-11/12 md:w-full sm:w-full rounded-lg lg:min-h-[320px] md:min-h-[300px] sm:min-h-[200px] bg-center bg-cover bg-no-repeat"
          />
        </div>
      </div>
    </section>
  );
};

const InfoGraphicsSection = ({ data }) => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex flex-col gap-12">
      {data?.map((infoSection, index) => {
        return (
          <div
            key={index}
            className={`w-full flex  items-center lg:gap-12 md:gap-6 sm:gap-6 ${
              index % 2 === 1
                ? "lg:flex-row md:flex-col-reverse sm:flex-col-reverse"
                : "lg:flex-row-reverse md:flex-col-reverse sm:flex-col-reverse"
            }`}
          >
            <div className="lg:w-1/2 md:w-full sm:w-full my-auto">
              <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-6">
                {infoSection?.title}
              </h2>
              <ul className="list-disc p-4">
                {infoSection?.content?.map((contentList, index1) => {
                  return <li key={index1}>{contentList}</li>;
                })}
              </ul>
            </div>
            <div
              style={{ backgroundImage: `url(${infoSection?.imgUrl})` }}
              className="lg:w-1/2 md:w-full sm:w-full rounded-lg lg:min-h-[348px] md:min-h-[300px] sm:min-h-[200px] bg-center bg-cover bg-no-repeat"
            />
          </div>
        );
      })}

      {/* CTA */}
      {/* <button className="mx-auto w-fit px-8 py-3 rounded bg-black text-white font-semibold">
        {" "}
        Start your collection
      </button> */}
    </section>
  );
};

const InspirationalSection = () => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 border-y">
      <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-6">
        Ideal for Professional Dealers
      </h2>
      <p>
        Do you have at least 50 watches to sell with an average value of $2,000
        each? Then you've come to the right place! Register for free and create
        your WristLink dealer account. Not a professional dealer? Information
        for private sellers{" "}
      </p>
    </section>
  );
};
const InspirationalSlide = ({ data }) => {
  const scrollRef = useRef(null);
  const [cardsWidthToFit, setCardsWidthToFit] = useState(1080); // Default to at least 1 card

  useEffect(() => {
    const calculateFit = () => {
      const parentWidth = scrollRef.current
        ? scrollRef.current.clientWidth
        : 1080;
      setCardsWidthToFit(parentWidth); // Ensure at least 1 card fits
    };

    calculateFit(); // Run initially
    window.addEventListener("resize", calculateFit); // Adjust on window resize
    return () => window.removeEventListener("resize", calculateFit); // Cleanup
  }, []);

  // console.log(cardsWidthToFit);

  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 border-b">
      <h2 className="lg:text-3xl md:text-2xl sm:text-xl text-center mb-6">
        Become a Successful Dealer on WristLink in 3 Easy Steps
      </h2>

      <div className="mx-auto  flex gap-4 items-center w-full mb-12">
        {/* LEFT TOGGLE */}
        <button
          onClick={() => {
            scrollRef.current.scrollBy({
              left: -1 * cardsWidthToFit,
              behavior: "smooth",
            });
          }}
          className={" "}
        >
          {ChevronLeft}
        </button>
        {/* MAIN SLIDE */}
        <div
          ref={scrollRef}
          className="overflow-x-scroll no-scrollbar flex border rounded-lg"
        >
          {data?.map((slide, index) => {
            return (
              <div
                key={index}
                style={{ minWidth: cardsWidthToFit }}
                className={` p-6 flex lg:flex-row md:flex-row sm:flex-col items-center gap-2`}
              >
                <div className="lg:w-5/12 md:w-5/12 sm:w-full flex justify-center items-center lg:mb-0 md:mb-0 sm:mb-4">
                  <div
                    className="relative w-full rounded-lg overflow-hidden"
                    style={{ paddingTop: "100%" }}
                  >
                    <div
                      className="absolute inset-0"
                      style={{
                        backgroundImage: `url(${slide?.imgUrl})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    />
                  </div>
                </div>
                <div className="lg:w-7/12 md:w-7/12 sm:w-full">
                  <h3 className="lg:text-lg md:text-lg sm:text-md lg:text-left md:text-left sm:text-center font-medium mb-4">
                    {slide?.title}
                  </h3>
                  <p className="lg:text-[16px] md:text-[14px] sm:text-[12px]  md:text-left sm:text-center ">
                    {slide?.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        {/* RIGHT TOGGLE */}
        <button
          onClick={() => {
            scrollRef.current.scrollBy({
              left: cardsWidthToFit,
              behavior: "smooth",
            });
          }}
          className={""}
        >
          {ChevronRight}
        </button>
      </div>
    </section>
  );
};

const InspirationalSection3 = ({ data }) => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 ">
      <h2 className="lg:text-3xl md:text-2xl sm:text-xl text-center mb-20">
        Become a WristLink Dealer and Take Your Sales Numbers to the Next Level
      </h2>

      <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4">
        {data?.map((feature, index) => {
          return (
            <div key={index} className="p-8">
              <div className="mb-4 w-4/12 mx-auto">
                <div
                  className="relative w-full rounded-lg overflow-hidden "
                  style={{ paddingTop: "100%" }}
                >
                  <div
                    className="absolute inset-0"
                    style={{
                      backgroundImage: `url(${feature?.imgUrl})`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                    }}
                  />
                </div>
              </div>

              <h3 className="lg:text-lg md:text-lg sm:text-md font-medium mb-4 text-center">
                {feature?.title}
              </h3>
              <p className="lg:text-[14px] md:text-[14px] sm:text-[12px] text-center">
                {feature?.description}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

const ProfessionalPackageSection = ({ watchPricingTiers, dealerFeatures }) => {
  return (
    <section className="lg:px-2 md:px-4 sm:px-4 lg:py-4 md:py-4 sm:py-4">
      <div className="max-w-[1200px] min-h-[470px] mx-auto py-12 bg-secondary text-white rounded-lg ">
        <h2 className="lg:text-3xl md:text-2xl sm:text-xl mx-auto text-center font-semibold mb-0">
          The Professional Package –
        </h2>
        <h2 className="lg:text-3xl md:text-2xl sm:text-xl  mx-auto text-center font-semibold mb-6">
          A Package Tailored to Your Needs
        </h2>

        {/* BANNER CONTENT  */}
        <div className="lg:px-12 md:px-8 sm:px-6 py-4 flex lg:flex-row md:flex-col sm:flex-col items-center gap-4">
          <div className="lg:w-1/2 md:w-full sm:w-full">
            {watchPricingTiers?.map((tire, index) => {
              return (
                <div
                  key={index}
                  className={`flex items-center text-black text-[15px] ${
                    index % 2 === 0 ? "bg-white" : "bg-primarylight"
                  }`}
                >
                  <p className="w-1/2 py-3 px-2.5 text-center border-r">
                    {tire?.watches}{" "}
                  </p>
                  <p className="w-1/2 py-3 px-2.5 text-center">
                    {tire?.price}{" "}
                  </p>
                </div>
              );
            })}
          </div>
          <div className="lg:w-1/2 md:w-full sm:w-full">
            {dealerFeatures?.map((feature, index2) => {
              return (
                <div key={index2} className="flex items-center gap-4 p-3">
                  <img
                    src={feature?.icon}
                    alt=""
                    width={72}
                    height={72}
                    className="rounded-full border p-4 bg-primarylight"
                  />
                  <p className="lg:text-[15px] md:text-[14px] sm:text-[13px]">
                    {feature?.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

const FaqSection = ({ faqs }) => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 ">
      <FaqAndContactSection faqs={faqs} />
    </section>
  );
};

const DelarRegistration = ({ style }) => {
  return (
    <nav
      style={{ ...style }}
      className="z-10 sticky top-0  shadow-xl bg-secondary text-white"
    >
      <div className="p-5 max-w-[1200px] mx-auto flex items-center justify-between">
        <h3 className="lg:text-2xl md:text-xl sm:text-lg font-semibold mb-0">
          Try Wrist-Wurx for 30 days
        </h3>

        {/* CTA BTN */}
        <Link
          to={"/dealer-info/get-started"}
          className="border hover:bg-primary transition-all ease-in-out rounded-lg py-2.5 px-10 "
        >
          {" "}
          Register Now
        </Link>
      </div>
    </nav>
  );
};
